import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DomainValueType } from '@app/core/enums/domain-values.enum';
import { IDomainValue } from '@app/core/interfaces/domain-value.interface';
import { DomainValuesSharedService } from '@app/core/services/domain-values.shared.service';
import { SharedLibModule } from '@app/core/shared-lib/shared-lib.module';
import { Observable } from 'rxjs';
import { ITimelineItem } from '../interfaces/timeline-item.interface';

@Component({
  selector: 'timeline-content',
  templateUrl: './timeline-content.component.html',
  standalone: true,
  imports: [SharedLibModule],
})
export class FiTimelineContentComponent implements OnInit, OnChanges {
  @Input() items: ITimelineItem[] = [];
  @Output() scheduleEvent = new EventEmitter();
  @Output() resultEvent = new EventEmitter<string>();
  filterOptions = [
    { label: 'Tutte', value: 'tutte' },
    { label: 'Sistema', value: 'sistema' },
    { label: 'Eventi', value: 'events' },
  ];

  domainValuesList$?: Observable<IDomainValue[]>;
  eventMediums?: IDomainValue[];
  eventTypes?: IDomainValue[];
  eventStates?: IDomainValue[];
  filter = 'events';
  filteredItems: ITimelineItem[] = [];

  constructor(private domainValuesService: DomainValuesSharedService) {}

  ngOnChanges(): void {
    this.onFilterChange();
  }

  ngOnInit(): void {
    this.domainValuesList$ = this.domainValuesService.getDomainValues();
    this.domainValuesList$.subscribe((res) => {
      this.eventMediums = res.filter((d: IDomainValue) => d.type === DomainValueType.EVENT_MEDIUM);
      this.eventTypes = res.filter((d: IDomainValue) => d.type === DomainValueType.EVENT_TYPE);
      this.eventStates = res.filter((d: IDomainValue) => d.type === DomainValueType.EVENT_STATE);
    });
  }

  getEventLabel(eventType: number) {
    return this.eventTypes?.find((e) => e.code == eventType)?.label;
  }

  getEventState(eventState: number) {
    return this.eventStates?.find((e) => e.code == eventState)?.label;
  }

  onFilterChange() {
    switch (this.filter) {
      case 'tutte':
        this.filteredItems = this.items;
        break;
      case 'sistema':
        this.filteredItems = this.items.filter((item) => item.type === 'project_sale_opportunity' || item.type === 'project_sale_lead');
        break;
      case 'events':
        this.filteredItems = this.items.filter((item) => item.type === 'event');
    }
  }

  onScheduleEvent() {
    this.scheduleEvent.emit();
  }

  onResultEvent(eventId: string) {
    this.resultEvent.emit(eventId);
  }
}
